import Vue from 'vue'
import VueI18n, { LocaleMessages } from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages (): LocaleMessages {
  const locales = require.context('@/i18n/messages', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages: LocaleMessages = {}

  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)

    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })

  return messages
}

export default new VueI18n({
  locale: localStorage.getItem('uiLanguageCodeCp') || navigator.language || process.env.VUE_APP_I18N_LOCALE || 'sk',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'sk',
  messages: loadLocaleMessages()
})